<div class="flex flex-wrap mt-8 mb-6">

    @let group = (group$ | async);

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo="/groups"></app-btn-back>
        <div class="flex gap-2 justify-center">
            @if ((myRoles$ | async)?.management && group?.memberStatus ==
            membershipStatus.active) {
            <app-btn-whatsapp [phoneNumber]="phoneNumber" [message]="inviteText + groupId"
                [btnText]="'Invite to Join'"></app-btn-whatsapp>
            }
        </div>
    </div>

    <div class="mb-2 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            Members
        </h1>
    </div>


    <div class="w-full">
        <!-- Tabs Navigation -->
        <div class="border-b border-gray-200">
            <nav class="flex space-x-4">
                <button (click)="setActiveTab('faculty')"
                    [class]="activeTab === 'faculty' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Faculty
                </button>
                <button (click)="setActiveTab('students')"
                    [class]="activeTab === 'students' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Students
                </button>
                <button (click)="setActiveTab('parents')"
                    [class]="activeTab === 'parents' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Parents
                </button><button (click)="setActiveTab('alumni')"
                    [class]="activeTab === 'alumni' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Alumni
                </button>
                <button (click)="setActiveTab('new')"
                    [class]="activeTab === 'new' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    New Requests
                </button>
            </nav>
        </div>

        <!-- Tab Content -->
        <div class="mt-6">
            @if(activeTab === 'faculty') {
            <app-list-faculty></app-list-faculty>
            } @else if(activeTab === 'students') {
            <app-list-students></app-list-students>
            } @else if(activeTab === 'parents') {
            <app-list-parents></app-list-parents>
            } @else if(activeTab === 'alumni') {
            <app-list-alumni></app-list-alumni>
            } @else if (activeTab === 'new') {
            <app-list-unassigned></app-list-unassigned>
            }
        </div>
    </div>
</div>